import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authLink } from '../utils/authReturnPath';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  
  if (!token) {
    return <Navigate to={authLink('/login', location.pathname + location.search + location.hash)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
